import * as async from 'async';
// import * as queryString from 'querystring';

// import * as config from '../../config';
import ErrorHandler from '../error_handler/error_handler';
import * as HttpUtils from '../../util/http_utils';
import Errors from './errors';
import config from '../../config';

export default {

    /**
     * Initializes and starts the concurrency lock request chain.
     * @param {Object} params
     * @param {String} params.mpxToken The MpxToken to the platform
     * @param {String} params.globalUserId The id from the ESB
     * @param {String} params.sessionToken The session token used for requests to the ESB
     * @param {String} params.selectorServiceUrl The selector service Url, parsed from the manifest. Starts with link.theplatform.com
     * @param {Function} callback - On success
     *
     * @throws Error on failure
     */
    initialize(params, callback) {
        this.params = params;
        this.clientId = null;
        this.smilObject = {
            concurrencyInstance: null,
            updateLockInterval: null, // heart beat seconds
            concurrencyServiceUrl: null, // updateURL/content unlockURL
            lockId: null,
            lockSequenceToken: null,
            lock: null
        };
        async.waterfall([
            (callback) => this._concurrencyCheck((success) => callback(!success))
        ], (err) => {
            if (err) {
                callback(true);
            } else {
                this._throwError(Errors.TOO_MANY_STREAMS_ERROR, {
                    reason: 'The general flow failed. This might be a false positive'
                });
                return false;
            }
        });
    },

    /**
     * Removes the concurrency lock of the resource.
     * @param callback
     * @return {boolean}
     * @private
     */
    _concurrencyCheck(callback) {
        const spConfig = window.sessionStorage.getItem('SPConf');
        const configuration = JSON.parse(atob(spConfig));
        var packageName = this.params.packageName || configuration.packageName;
        var concurrency = this.params.concurrency || configuration.concurrency;
        var packageParent = this.params.packageParent || configuration.packageParent;
        var subscriptionIncludesVal = this.params.subscriptionIncludes || configuration.subscriptionIncludes;
        var subscriptionIncludes = subscriptionIncludesVal && subscriptionIncludesVal !== "false" && packageParent && packageParent !== "false" ? subscriptionIncludesVal + ',' + packageParent : subscriptionIncludesVal && subscriptionIncludesVal !== "false" ? subscriptionIncludesVal : packageName;
        var subscriptionIncludesArray = subscriptionIncludes ? subscriptionIncludes.split(',') : [];
        var sessionId = this.params.sessionId || configuration.sessionId;
        if (concurrency && concurrency !== "false" && concurrency !== "undefined") {
            const unlockUri = `${config.recEngineNewUrl}/concurrency/check/${this.params.globalUserId}`;
            HttpUtils.get({
                uri: unlockUri,
                headers: {
                    'x-session-id': `${sessionId}`
                }
            }, (success, body) => {
                body = JSON.parse(body);
                var packages = body.packages;
                var concurrencyFromPackages = 0;
                if (packages.length) {
                    subscriptionIncludesArray.forEach(function(channelname) {
                        packages.forEach(function(packageName) {
                            if (packageName.package === channelname) {
                                concurrencyFromPackages += packageName.count;
                            }
                        });
                    });
                }
                var baseConcurrencyFromConfig = concurrency;
                var canPlayContent = true;
                if (concurrencyFromPackages) {
                    canPlayContent = this._canPlayFromPackages(concurrencyFromPackages, baseConcurrencyFromConfig, packageName);
                }
                if (!canPlayContent) {
                    this._throwError(Errors.TOO_MANY_STREAMS_ERROR, {
                        uri: unlockUri,
                        body: body,
                        reason: 'concurrency error'
                    });
                } else {
                    callback(false);
                }
            });
        } else {
            callback(false);
        }
    },

    _canPlayFromPackages(concurrencyFromPackages, baseConcurrencyFromConfig, packageName) {
        if (concurrencyFromPackages && baseConcurrencyFromConfig && packageName) {
            if (concurrencyFromPackages >= baseConcurrencyFromConfig) {
                return false;
            }
        }
        return true;
    },

    /**
     * Handles errors for concurrency
     * @param error
     * @param dev
     * @private
     */
    _throwError(error, dev) {
        if (this.isThrown) return;
        this.isThrown = true;
        // this._unlockIfActive(); // Try to unlock, might not be possible
        ErrorHandler.throwError(error, dev);
    }
};



// WEBPACK FOOTER //
// ./src/modules/concurrency/concurrency.js